import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import i18next from '../lang';

interface PurchaseStepperProps {
	activeStep: number;
}

const steps = [
	'purchase.step_delivery_address',
	'purchase.step_delivery_datetime',
	'purchase.step_order_input',
	'purchase.step_order_confirm',
	'purchase.step_final_confirm'
];

const PurchaseStepper: React.FC<PurchaseStepperProps> = ({ activeStep }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Box sx={{ width: '100%', mb: 3 }}>
			<Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
				{steps.map((step, index) => (
					<React.Fragment key={step}>
						{/* ステップの丸 */}
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
							<Box sx={{
								width: index <= activeStep ? 28 : 24,
								height: index <= activeStep ? 28 : 24,
								borderRadius: '50%',
								backgroundColor: index <= activeStep ? 'primary.main' : '#e0e0e0',
								border: index === activeStep ? '3px solid' : 'none',
								borderColor: 'primary.dark',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								transition: 'all 0.3s ease'
							}}>
								<Typography sx={{
									color: index <= activeStep ? '#fff' : '#999',
									fontSize: '0.7rem',
									fontWeight: 'bold',
									lineHeight: 1
								}}>
									{index + 1}
								</Typography>
							</Box>
							<Typography sx={{
								fontSize: isMobile ? '0.55rem' : '0.7rem',
								color: index <= activeStep ? 'text.primary' : '#999',
								fontWeight: index === activeStep ? 'bold' : 'normal',
								mt: 0.5,
								textAlign: 'center',
								whiteSpace: 'nowrap'
							}}>
								{i18next.t(step)}
							</Typography>
						</Box>
						{/* ステップ間の線 */}
						{index < steps.length - 1 && (
							<Box sx={{
								flex: 1,
								height: 3,
								backgroundColor: index < activeStep ? 'primary.main' : '#e0e0e0',
								mx: 0.5,
								mb: 2.5,
								borderRadius: 1,
								transition: 'background-color 0.3s ease'
							}} />
						)}
					</React.Fragment>
				))}
			</Box>
		</Box>
	);
};

export default PurchaseStepper;
